import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'
import { CardContent, CardMedia } from '@mui/material'
import DefaultImageNews from '../../../assets/images/default-news.png'

export default function CardNews({ newsData }) {
  const imageSrc = newsData.image || DefaultImageNews

  const formattedDate = newsData.publishedAt
    ? new Date(newsData.publishedAt).toLocaleDateString('fr-FR')
    : ''

  return (
    <Card
      sx={{
        maxWidth: 'calc(33.33% - 40px )',
        width: 'calc(33.33% - 40px)',
        minHeight: 425,
        maxHeight: 425,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        borderRadius: '8px',
      }}
    >
      <CardMedia
        component="img"
        height="140"
        minHeight="140"
        image={imageSrc}
        alt="news image"
      />
      <CardContent sx={{ padding: '20px 35px', flexGrow: 1, pb: 3 }}>
        <Typography
          variant="h5"
          component="div"
          sx={{
            lineHeight: '26px',
            fontSize: 16,
            textAlign: 'start',
            marginTop: 1,
          }}
          dangerouslySetInnerHTML={{ __html: newsData.description }}
        ></Typography>
      </CardContent>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          fontSize: 13,
          position: 'absolute',
          bottom: 0,
          left: '15px',
          pb: 2,
          fontWeight: 'bold',
          color: 'black',
        }}
      >
        {formattedDate}
      </Typography>
    </Card>
  )
}
